import { Link } from "react-router-dom";
import { useRouteContext } from "../lib/route-context";

export function Breadcrumb() {
  const { crumbs } = useRouteContext();
  if (crumbs.length <= 1) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className="border-b border-[var(--rule-strong)] bg-[var(--card-soft)]"
    >
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex flex-wrap items-center gap-x-1 gap-y-1 text-xs text-[var(--muted-strong)]">
        {crumbs.map((c, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <span className="text-[var(--muted)]">›</span>}
            {c.href ? (
              <Link to={c.href} className="hover:text-[var(--fg)] hover:underline">
                {c.label}
              </Link>
            ) : (
              <span className={i === crumbs.length - 1 ? "text-[var(--fg)]" : ""}>
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
